export function initBlogFilters(loadPostsCallback) {
    const toggles = document.querySelectorAll('.blog-filter-toggle');
    const dropdowns = document.querySelectorAll('.blog-filter-dropdown');
  
    if (toggles.length === 0 || dropdowns.length === 0) return;
  
    toggles.forEach(toggle => {
      const key = toggle.dataset.filter;
      const dropdown = document.querySelector(`.blog-filter-dropdown[data-filter="${key}"]`);
      if (!dropdown) return;
  
      toggle.addEventListener('click', () => {
        dropdown.classList.toggle('open');
        toggle.classList.toggle('open');
      });
    });
  
    document.addEventListener('click', e => {
      dropdowns.forEach(dropdown => {
        const toggle = dropdown.previousElementSibling;
        if (!dropdown.contains(e.target) && !toggle.contains(e.target)) {
          dropdown.classList.remove('open');
          toggle.classList.remove('open');
        }
      });
    });
  
    const clears = document.querySelectorAll('.blog-filter-clear');
    clears.forEach(btn => {
      const filter = btn.dataset.filter;
      if (!filter) return;
  
      btn.addEventListener('click', () => {
        const checkboxes = document.querySelectorAll(`input[name="${filter}"]`);
        checkboxes.forEach(cb => cb.checked = false);
        updateFilterCounts();
        loadPostsCallback(getSelectedFilters());
      });
    });
  
    const filterInputs = document.querySelectorAll('.blog-filter-dropdown input[type="checkbox"]');
    if (filterInputs.length > 0) {
      filterInputs.forEach(cb => {
        cb.addEventListener('change', () => {
          updateFilterCounts();
          loadPostsCallback(getSelectedFilters());
        });
      });
    }
  
    function getSelectedFilters() {
      const filters = {};
      ['topic', 'segment'].forEach(type => {
        const checked = document.querySelectorAll(`input[name="${type}"]:checked`);
        if (checked.length > 0) {
          filters[type] = Array.from(checked).map(cb => cb.value);
        }
      });
      return filters;
    }
  
    function updateFilterCounts() {
      toggles.forEach(toggle => {
        const filter = toggle.dataset.filter;
        const count = document.querySelectorAll(`input[name="${filter}"]:checked`).length;
        const countSpan = toggle.querySelector('.count');
        if (countSpan) {
          countSpan.textContent = count > 0 ? `(${count})` : '';
        }
      });
  
      renderActiveFilters();
    }
  
    function renderActiveFilters() {
      const container = document.getElementById('activeFilters');
      if (!container) return;
  
      container.innerHTML = '';
  
      ['topic', 'segment'].forEach(type => {
        const checkboxes = document.querySelectorAll(`input[name="${type}"]:checked`);
        checkboxes.forEach(cb => {
          const pill = document.createElement('div');
          pill.className = 'tmp-overviewblog__filters-pill';
          pill.innerHTML = `
            <span>${cb.parentElement.textContent.trim()}</span>
            <span class="tmp-overviewblog__filters-pill-remove" data-type="${type}" data-value="${cb.value}">&times;</span>
          `;
          container.appendChild(pill);
        });
      });
  
      container.querySelectorAll('.tmp-overviewblog__filters-pill-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          const type = btn.dataset.type;
          const value = btn.dataset.value;
          const checkbox = document.querySelector(`input[name="${type}"][value="${value}"]`);
          if (checkbox) {
            checkbox.checked = false;
            updateFilterCounts();
            loadPostsCallback(getSelectedFilters());
          }
        });
      });
    }
  
    updateFilterCounts();
    loadPostsCallback(getSelectedFilters());
  }
  